export const CREATOR_UNKNOWN = 'unknown' as const;
export const DEFAULT_MEASUREMENT_UNIT = 'IN' as const;
export const WIDTH_STATIC_TILE_IMAGE = 240;
